import { styled } from "@mui/material/styles";
import { Box, Typography, Avatar, IconButton, alpha } from "@mui/material";
import FlexBox from "../Flexbox";
import { APP_COLORS, APP_FONT_FAMILIES, APP_TEXT_SIZES } from "../../../enums";

export const HeaderIconsContainer = styled(FlexBox)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 16,
  [theme.breakpoints.down("lg")]: {
    gap: 8,
  },
  [theme.breakpoints.down("sm")]: {
    gap: 4,
  },
}));

export const HeaderProfileDivider = styled(Box)({
  width: "1px",
  height: "38px",
  backgroundColor: APP_COLORS.headerDivider,
});

export const HeaderProfileSection = styled(FlexBox)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  padding: "0px 20px 0px 0px",
  gap: 8,
  cursor: "pointer",
  "&:hover": {
    opacity: 0.9,
  },
  [theme.breakpoints.down("lg")]: {
    paddingRight: 12,
    gap: 6,
  },
  [theme.breakpoints.down("sm")]: {
    paddingRight: 0,
    gap: 4,
  },
}));

export const HeaderProfileInfo = styled(FlexBox)({
  flexDirection: "row",
  alignItems: "center",
  gap: 4,
});

export const HeaderProfileTextContainer = styled(FlexBox)({
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 4,
});

export const HeaderProfileNameContainer = styled(FlexBox)({
  flexDirection: "row",
  alignItems: "center",
  gap: 4,
});

export const HeaderProfileName = styled(Typography)({
  color: APP_COLORS.white,
  fontSize: APP_TEXT_SIZES.body,
  fontWeight: 400,
  fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
  lineHeight: "22px",
  letterSpacing: "-0.02em",
});

export const HeaderProfileEmail = styled(Typography)({
  color: APP_COLORS.primaryLight3,
  fontSize: APP_TEXT_SIZES.small,
  fontWeight: 400,
  fontFamily: APP_FONT_FAMILIES.ibmPlexMono,
  lineHeight: "16px",
});

export const HeaderProfileChevron = styled(FlexBox)({
  alignItems: "center",
  color: APP_COLORS.primaryLight3,
  "& svg": {
    width: 16,
    height: 16,
  },
});

export const HeaderProfileAvatar = styled(Avatar)({
  width: 40,
  height: 40,
  backgroundColor: APP_COLORS.orange,
});

export const HeaderIconButton = styled(IconButton)({
  width: 38,
  height: 38,
  minWidth: 38,
  minHeight: 38,
  border: `1px solid ${APP_COLORS.headerDivider}`,
  borderRadius: "42px",
  padding: "0px 10.5556px",
  color: APP_COLORS.headerIconColor,
  "& svg": {
    width: 20,
    height: 20,
    color: APP_COLORS.headerIconColor,
    "& path": {
      fill: APP_COLORS.headerIconColor,
    },
  },
  "&:hover": {
    backgroundColor: alpha(APP_COLORS.headerIconColor, 0.1),
    borderColor: APP_COLORS.headerIconColor,
  },
  "&.MuiIconButton-sizeSmall": {
    width: 38,
    height: 38,
    minWidth: 38,
    minHeight: 38,
  },
});

